import dispatcher from '../dispatcher';
import SplitText from '../../libs/SplitText';
// import colorStore from '../color/color.store';
// import objectsStore from '../stage/bg-objects.store';

var colorStore, objectsStore;
var elementProto = Object.create(HTMLHeadingElement.prototype);

function translateTo(el, translate, opacity, speed, delay, easing) {
	var ease = easing || 'ease';
	var transition = 'transform ' + speed + 's ' + ease + ' ' + delay + 's,' +
		'opacity ' + speed + 's ' + ease + ' ' + delay + 's';

	if (!el || !el.style) return; // hi microsoft edge

	el.style.transition =
		el.style.webkitTransition = transition;

	el.style.transform =
		el.style.webkitTransform = 'translateX(' + translate[0] + 'px)' +
			'translateY(' + translate[1] + 'px)' +
			'translateZ(' + translate[2] + 'px)';

	el.style.opacity = opacity;
}

var _handleMouseenter = function(el, index) {
	var color = el.getAttribute('data-color');

	if (this._hiding) return;

	this._active = el;


	// IMPORTANT
	// Блок отвечает за анимацию по ховеру на главном экране
	// когда при ховере появляются таблеточки и меняются на колбы
	/*
    dispatcher.dispatch({
      type: 'color:change',
      color: color
    });
    dispatcher.dispatch({
      type: 'bg-objects:set-group',
      groupId: index
    });

	 */

    dispatcher.dispatch({
      type: 'indicator:on',
      index: index
    });

    this.classList.add('word-hovered');

    // this._textSplit.words.forEach(function(wd) {
    // 	if (wd.parentNode === el) {
    // 		wd.style.opacity = 1;
    // 		wd.style.transform = 'translateZ(0px)';
    // 	} else {
    // 		wd.style.opacity = 0.3;
    // 		wd.style.transform = 'translateZ(' + (0) + 'px)';
    // 	}
    // });
    clearTimeout(this._to);
  }

  var _handleMouseleave = function(el) {
    if (this._active !== el) return;
    if (this._hiding) return;

    this.classList.remove('word-hovered');

    this._active = null;

    dispatcher.dispatch({
      type: 'color:change',
      color: 'purple'
    });

    this._to = setTimeout(function() {
      dispatcher.dispatch({
        type: 'bg-objects:set-group',
        groupId: -1
      });
    }, 1500);

    // this._textSplit.words.forEach(function(wd) {
    // 	wd.style.opacity = 1;
    // 	wd.style.transform = 'translateZ(0px)';
    // });
  }

  var _handleDispatcher = function(e) {
    var self = this;

    if (this._hiding) return;

    // if (e.type === '3d:hide') {
    // 	this._hiding = true;
    // 	this._textSplit.words.forEach(function(wd) {
    // 		var w = wd;
    // 		if (wd.parentNode === self._active) return;
    // 		translateTo(wd, [0, 0, -100 * Math.random() -10], 0, 0.45, 0, 'ease-in');
    // 	});
    // }
  }

  elementProto.createdCallback = function() {
    this._active = null;

    this.handleMouseenter = _handleMouseenter.bind(this);
    this.handleMouseleave = _handleMouseleave.bind(this);
    this.handleDispatcher = _handleDispatcher.bind(this);
  }
  elementProto.attachedCallback = function() {
    var self = this;

    this._anchors = this.getElementsByTagName('a');
    this._textSplit = new SplitText(this, {type: 'words'});

    this._textSplit.words.forEach(function(wd) {
      wd.classList.add('jgp');
      wd.setAttribute('data-type', 'h1');
      // wd.style.transitionProperty = 'transform, opacity';
      // wd.style.transformStyle = 'preserve-3d';
      // wd.style.transitionDuration = '0.6s';
    });

    if (Modernizr.mobile || Modernizr.touchevents)
      return;

    Promise
    .all([
      import(/* webpackPrefetch: true */ '../color/color.store'),
		import(/* webpackPrefetch: true */ '../stage/bg-objects.store')
	])
	.then(([csm, osm]) => {
		colorStore = csm;
		objectsStore = osm;
	});

	Array.prototype.forEach.call(this._anchors, function(a, index) {
		a.addEventListener('mouseenter', function() {
			self.handleMouseenter(a, index);
		});
		a.addEventListener('mouseleave', function() {
			self.handleMouseleave(a, index);
		});

		a.addEventListener('click', function(e) {
			self.classList.add('word-hovered');
			self._hiding = true;

			if (!Modernizr.touchevents) {
				a.classList.add('hover');
			}
		});
	});

	dispatcher.subscribe(this.handleDispatcher);
}
elementProto.detachedCallback = function() {
	dispatcher.unsubscribe(this.handleDispatcher);
}

document.registerElement('main-header', {
	prototype: elementProto,
	extends: 'h1'
});
